import React from "react";
import { makeStyles } from "@material-ui/core";
import moment from "moment-timezone";
import axios from "axios";


// 2. Function to initialize and store the S3 base URL
let s3_base_url = "";
const getImageBaseUrl = async () => {
  try {
    const response = await axios.get("https://api.gamerji.tech/api/bucket/url");
    return { success: true, data: response.data };
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.message || "An error occurred",
      status: error?.response?.status || 500,
    };
  }
};
// 2. Initialize and store the base URL once when app loads
const initializeS3BaseUrl = async () => {
  const result = await getImageBaseUrl();
  if (!result.success) {
    // console.error("Error fetching S3 base URL:", result.message);
    s3_base_url = process.env.REACT_APP_S3_BASE_URL || "";
  } else {
    s3_base_url = result.data.url;
    // console.log("S3 Base URL fetched successfully:", s3_base_url);
  }
};

initializeS3BaseUrl();

export const StatusCssClasses = ["success", "danger", ""];
export const StatusTitles = ["Active", "In Active"];
export const VideoStatusCssClasses = [
  "",
  "warning",
  "success",
  "info",
  "danger",
];
export const VideoStatusTitles = [
  "",
  "Pending",
  "Approved",
  "On Hold",
  "Rejected",
];
export const TicketStatusCssClasses = [
  "",
  "warning",
  "info",
  "info",
  "success",
  "danger",
];
export const TicketStatusTitles = [
  "",
  "Pending",
  "Replied",
  "In Progress",
  "Approved",
  "Rejected",
];

export const WithdrawalStatusCssClasses = [
  "",
  "warning",
  "success",
  "info",
  "danger",
];
export const WithdrawalStatusTitles = [
  "",
  "Pending",
  "Approved",
  "On Hold",
  "Rejected",
];
export const WithdrawalModeTitles = ["", "Bank", "UPI", "PayTM", "Amazon Pay"];
export const ConditionCssClasses = ["success", "danger", ""];
export const ConditionTitles = ["New", "Used"];
export const defaultSorted = [{ dataField: "id", order: "asc" }];
export const limit = 10;
export const skip = 0;
export const page = 1;
// export const imageUrl = `${process.env.REACT_APP_UPLOADED_FILE_URL}/`;

// export const imageUrl = (filename = "") => {
//   if (!s3_base_url) {
//     console.warn("S3 base URL not initialized!");
//     return filename;
//   }

//   const cleanBase = s3_base_url.endsWith("/") ? s3_base_url : s3_base_url + "/";
//   return `${cleanBase}${filename}`;
// };
export const imageUrl = (filename = "") => {
  if (!s3_base_url) {
    console.warn("S3 base URL not initialized!");
    return filename;
  }
  // Ensure no double slashes or missing slashes
  const cleanBase = s3_base_url.endsWith("/") ? s3_base_url : `${s3_base_url}/`;
  // Remove leading slash from filename if exists
  const cleanFilename = filename.startsWith("/") ? filename.slice(1) : filename;
  return `${cleanBase}${cleanFilename}`;
};
export const exportUrl = `${process.env.REACT_APP_API_URL_EXPORT}/`;
export const gender = {
  M: "Male",
  F: "Female",
};
export const AdLogType = ["", "Impression", "Click"];
export const AmountType = ["", "Coin", "Avtar"];
// export const AmountType = ['','Point', 'Bonus', 'Reward Deposite', 'Coin', 'Rupee'];
export const TransactionType = [
  "Pending",
  "Credit",
  "Debit",
  "On Hold",
  "Rejected",
];
export const PaymentType = [
  "Pending",
  "Promotional",
  "join League",
  "Referral",
  "Refund",
  "Add Balance",
  "Withdrawal requested",
  "Withdrawal approved",
  "Withdrawal request rejected",
  "Won the league",
  "Deposit Bonus",
  "SignUp Codes",
  "Penalty or Charges",
  "Signup Bonus",
  "Duplicate Refunds",
  "FE Refunds",
  "Daily Reward",
  "Buy Coins",
  "Add Coins",
  "CoinReward Redeem",
  "Buy Coins",
  "Buy Avatar",
  "One time coin bonus",
  "Earn Coins",
];
export const couponTypes = {
  couponCode: "COUPON CODE",
  promoCode: "PROMO CODE",
  signupCode: "SIGNUP CODE",
  referalCode: "REFERAL CODE",
};
export const notifySentType = {
  "1": "PUSH",
  "2": "SMS",
  "3": "EMAIL",
};
export const notifySentTypeOptions = [
  { _id: undefined, name: "ALL" },
  { _id: "1", name: "PUSH" },
  { _id: "2", name: "SMS" },
  { _id: "3", name: "EMAIL" },
];
export const notifyTypeOptions = [
  { _id: undefined, name: "ALL" },
  { _id: "Followers", name: "Followers" },
  { _id: "roomIdPassword", name: "RoomId Password" },
  { _id: "contestCancelled", name: "Contest Cancelled" },
  { _id: "contestCompleted", name: "Contest Completed" },
];

export const gameListDropdownFilterDataFormat = (game_list) => {
  let temp1 = [
    {
      _id: undefined,
      name: "All",
      gameId: undefined,
      isSelected: true,
    },
  ];
  game_list.forEach((element, i) => {
    temp1.push({
      _id: i + 1,
      name: element.name,
      gameId: element._id,
      isSelected: false,
    });
  });
  return temp1;
};
export const gameListSearchableDropdownFilterDataFormat = (game_list) => {
  let temp1 = [];
  game_list.forEach((element, i) => {
    temp1.push({
      _id: i + 1,
      value: element._id,
      label: element.name,
    });
  });
  return temp1;
};
export const levelListDropdownFilterDataFormat = (dropdown_filter_data) => {
  var temp_dropdown_filter_data = dropdown_filter_data.map((item) => ({
    ...item,
    isSelected: false,
  }));
  temp_dropdown_filter_data = [{ _id: undefined, name: "All" }].concat(
    temp_dropdown_filter_data
  );
  if (temp_dropdown_filter_data.length > 0)
    temp_dropdown_filter_data[0].isSelected = true;

  return temp_dropdown_filter_data;
};
export const dashboardCommonVariables = () => {
  var fromDate = new Date();
  var toDate = new Date();

  var fromDateNewGMT = new Date(
    fromDate.getFullYear(),
    fromDate.getMonth(),
    fromDate.getDate(),
    0,
    0,
    0
  );
  var toDateNewGMT = new Date(
    toDate.getFullYear(),
    toDate.getMonth(),
    toDate.getDate(),
    23,
    59,
    59
  );

  var minutesToAdd = 330;
  var startDate = new Date(fromDateNewGMT.getTime() + minutesToAdd * 60000);
  var endDate = new Date(toDateNewGMT.getTime() + minutesToAdd * 60000);
  const initRange = {
    fromDate: fromDateNewGMT,
    toDate: toDateNewGMT,
  };

  const initialSettingsDateRange = {
    startDate: moment(new Date()),
    endDate: moment(new Date()),
    ranges: {
      Today: [moment(new Date()), moment(new Date())],
      Yesterday: [
        moment(new Date()).subtract(1, "days"),
        moment(new Date()).subtract(1, "days"),
      ],
      "Last 7 Days": [
        moment(new Date()).subtract(6, "days"),
        moment(new Date()),
      ],
      "Last 30 Days": [
        moment(new Date()).subtract(29, "days"),
        moment(new Date()),
      ],
      "This Month": [
        moment(new Date()).startOf("month"),
        moment(new Date()).endOf("month"),
      ],
      "Last Month": [
        moment(new Date())
          .subtract(1, "month")
          .startOf("month"),
        moment(new Date())
          .subtract(1, "month")
          .endOf("month"),
      ],
      "All Time": [moment("01-01-2000", "DD-MM-YYYY"), moment(new Date())],
    },
  };

  const useStyles = makeStyles((theme) => ({
    root: {
      margin: "auto",
    },
    paper: {
      width: 200,
      height: 230,
      overflow: "auto",
    },
    button: {
      margin: theme.spacing(0, 0),
      backgroundColor: "#181C32",
      color: "#fff",
      fontSize: "15px",
      textTransform: "capitalize",
      mr: 0,
      mb: 4,
      maxHeight: "38px",
    },
  }));

  return {
    initRange: initRange,
    initialSettingsDateRange: initialSettingsDateRange,
    useStyles: useStyles,
  };
};
export const analyticsCommonVariables = () => {
  var fromDate = new Date();
  var toDate = new Date();

  var fromDateNewGMT = new Date(
    fromDate.getFullYear(),
    fromDate.getMonth(),
    fromDate.getDate(),
    0,
    0,
    0
  );
  var toDateNewGMT = new Date(
    toDate.getFullYear(),
    toDate.getMonth(),
    toDate.getDate(),
    23,
    59,
    59
  );

  var minutesToAdd = 330;
  var startDate = new Date(fromDateNewGMT.getTime() + minutesToAdd * 60000);
  var endDate = new Date(toDateNewGMT.getTime() + minutesToAdd * 60000);
  const initRange = {
    fromDate: new Date(fromDateNewGMT.setDate(fromDateNewGMT.getDate() - 6)),
    toDate: toDateNewGMT,
  };

  const initialSettingsDateRange = {
    startDate: moment(new Date()).subtract(6, "days"),
    endDate: moment(new Date()),
    ranges: {
      Today: [moment(new Date()), moment(new Date())],
      // Yesterday: [
      //   moment(new Date()).subtract(1, "days"),
      //   moment(new Date()).subtract(1, "days"),
      // ],
      "Last 7 Days": [
        moment(new Date()).subtract(6, "days"),
        moment(new Date()),
      ],
      "Last 30 Days": [
        moment(new Date()).subtract(29, "days"),
        moment(new Date()),
      ],
      "This Month": [
        moment(new Date()).startOf("month"),
        moment(new Date()).endOf("month"),
      ],
      "Last Month": [
        moment(new Date())
          .subtract(1, "month")
          .startOf("month"),
        moment(new Date())
          .subtract(1, "month")
          .endOf("month"),
      ],
      "All Time": [moment("01-01-2000", "DD-MM-YYYY"), moment(new Date())],
    },
  };

  const useStyles = makeStyles((theme) => ({
    root: {
      margin: "auto",
    },
    paper: {
      width: 200,
      height: 230,
      overflow: "auto",
    },
    button: {
      margin: theme.spacing(0, 0),
      backgroundColor: "#181C32",
      color: "#fff",
      fontSize: "15px",
      textTransform: "capitalize",
      mr: 0,
      mb: 4,
      maxHeight: "38px",
    },
  }));

  return {
    initRange: initRange,
    initialSettingsDateRange: initialSettingsDateRange,
    useStyles: useStyles,
  };
};
export const dataTableNoData = () => {
  return (
    <div
      className="row my-4 w-100 justify-content-center align-items-center"
      style={{ fontSize: "20px", fontWeight: "600" }}
    >
      No Data Found
    </div>
  );
};
export const dropdownFilterDataFormat = (dropdown_filter_data) => {
  var temp_dropdown_filter_data = dropdown_filter_data.map((item) => ({
    ...item,
    isSelected: false,
  }));
  if (temp_dropdown_filter_data.length > 0)
    temp_dropdown_filter_data[0].isSelected = true;

  return temp_dropdown_filter_data;
};
export const dropdownFilterAPIDataFormat = (dropdown_filter_api_data) => {
  var temp_dropdown_filter_api_data = [
    { _id: undefined, name: "All", isSelected: true },
  ];

  dropdown_filter_api_data.forEach((element, i) => {
    if (element?._id !== undefined && element?._id !== null) {
      temp_dropdown_filter_api_data.push({
        _id: i + 1,
        name: element?._id,
        isSelected: false,
      });
    }
  });

  return temp_dropdown_filter_api_data;
};
export const checkboxFilterDataFormat = (checkbox_filter_data) => {
  var temp_checkbox_filter_data = checkbox_filter_data.map((item) => ({
    ...item,
    isSelected: false,
  }));

  return temp_checkbox_filter_data;
};
export const noDropdownData = [
  {
    _id: undefined,
    name: "Select...",
  },
];
export const retentionTypeOptions = [
  { _id: undefined, name: "ALL" },
  { _id: 1, name: "Email" },
  { _id: 2, name: "Push" },
  { _id: 3, name: "SMS" },
];
export const retentionSubTypeOptions = [
  { _id: undefined, name: "ALL" },
  { _id: 1, name: "Not active for 5 days" },
  { _id: 2, name: "Not active for 7 days" },
  { _id: 3, name: "Lost 3 contests" },
  { _id: 4, name: "Lost previous tournament after playing" },
];
export const buyCoinsBuyBundlesTypeOptions = [
  { _id: undefined, name: "ALL" },
  { _id: 1, name: "GamerJi Transaction Status" },
  { _id: 2, name: "Cashfree Transaction Status" },
  { _id: 3, name: "Payment Method" },
];
export const buyCoinsBuyBundlesGamerJiTransactionStatusOptions = [
  { _id: undefined, name: "ALL" },
  { _id: 1, name: "INITIATED" },
  { _id: 2, name: "PENDING" },
  { _id: 3, name: "SUCCESS" },
  { _id: 4, name: "FAILED" },
];
export const buyCoinsBuyBundlesCashfreeTransactionStatusOptions = [
  { _id: undefined, name: "ALL" },
  { _id: 1, name: "PENDING" },
  { _id: 2, name: "SUCCESS" },
  { _id: 3, name: "FAILED" },
  { _id: 4, name: "CANCELLED" },
  { _id: 5, name: "USER_DROPPED" },
];
export const cashfreeTransactionsTypeOptions = [
  { _id: undefined, name: "ALL" },
  { _id: 1, name: "Payment Mode" },
  { _id: 2, name: "Bank" },
  // { _id: 3, name: 'Status', },
];
export const mathExpressionDropdownData = [
  { _id: undefined, name: "All" },
  { _id: 1, name: "Equals To (==)" },
  { _id: 2, name: "Not Equals To (!=)" },
  { _id: 3, name: "Greater Than (>)" },
  { _id: 4, name: "Less Than (<)" },
  { _id: 5, name: "Greater Than Equals To (>=)" },
  { _id: 6, name: "Less Than Equals To (<=)" },
];
export const hoursSlotDropdownData = [
  { _id: undefined, name: "All" },
  { _id: 1, name: "12AM to 3AM" },
  { _id: 2, name: "3AM to 6AM" },
  { _id: 3, name: "6AM to 9AM" },
  { _id: 4, name: "9AM to 12PM" },
  { _id: 5, name: "12PM to 3PM" },
  { _id: 6, name: "3PM to 6PM" },
  { _id: 7, name: "6PM to 9PM" },
  { _id: 8, name: "9PM to 12AM" },
];
export const gameCurrencyCheckboxData = [
  // { _id: undefined, name: 'All', },
  { _id: 1, name: "Coin" },
  { _id: 2, name: "RMG" },
];
export const winningModelCheckboxData = [
  // { _id: undefined, name: 'All', },
  { _id: 1, name: "Rank" },
  { _id: 2, name: "Kill" },
  { _id: 3, name: "Rank + Kill" },
];
export const accountStatusCheckboxData = [
  // { _id: undefined, name: 'All', },
  { _id: 1, name: "Active" },
  { _id: 2, name: "Banned" },
];
export const differentDateTypes = [
  { _id: undefined, name: "All", value: undefined },
  { _id: 1, name: "Signup", value: "createdAt" },
  { _id: 2, name: "Last Active", value: "lastActiveAt" },
  { _id: 3, name: "Updated", value: "updatedAt" },
];
export const poMethodRadioData = [
  // { _id: undefined, name: 'All', },
  { _id: 1, name: "All Time" },
  { _id: 2, name: "Monthly" },
  { _id: 3, name: "Weekly" },
  { _id: 4, name: "Today" },
];
export const yesNODropdownData = [
  { _id: undefined, name: "Select..." },
  { _id: 1, name: "Yes" },
  { _id: 2, name: "No" },
];
export const walletSummaryTypeOptions = [
  { _id: undefined, name: "Select Type..." },
  { _id: 1, name: "Packs Purchased" },
  { _id: 2, name: "Avatars Purchased" },
  { _id: 3, name: "Bundles Usage" },
  { _id: 4, name: "One time Bonus" },
  { _id: 5, name: "Earn Coins" },
  { _id: 6, name: "Unclaimed Coins" },
  { _id: 7, name: "Reward Store - Redeem" },
  { _id: 8, name: "Daily Rewards" },
  { _id: 9, name: "Join League" },
  { _id: 10, name: "Promo Codes" },
  { _id: 11, name: "Referral Bonus" },
  { _id: 12, name: "Refund" },
  { _id: 13, name: "Signup Bonus" },
  { _id: 14, name: "Won League" },
  { _id: 15, name: "Add Coins" },
];
export const auditReasonTypeDropdownData = [
  { _id: undefined, name: "Select Type..." },
  { _id: 1, name: "Contest" },
  { _id: 2, name: "Tournament" },
  { _id: 3, name: "Player" },
];
export const deliveryStatusDropdownData = [
  { _id: undefined, name: "ALL" },
  { _id: 1, name: "PENDING" },
  { _id: 2, name: "DELIVERED" },
  { _id: 3, name: "FAILED" },
];
export const channelStatusDropdownData = [
  { _id: undefined, name: "ALL" },
  { _id: 1, name: "PENDING" },
  { _id: 2, name: "APPROVED" },
  { _id: 3, name: "REJECTED" },
];
export const requestStatusOptions = [
  { _id: undefined, name: "ALL" },
  { _id: "approved", name: "APPROVED" },
  { _id: "pending", name: "PENDING" },
  { _id: "rejected", name: "REJECTED" },
];

export const paymentStatusOptions = [
  { _id: "SUCCESS", name: "SUCCESS" },
  { _id: "PENDING", name: "PENDING" },
  { _id: "FAILED", name: "FAILED" },
];
export const transPaymentOption = [
  { _id: 5, name: "Add Balance" },
  { _id: 6, name: "Withdrawal Requested" },
  { _id: 7, name: "Withdrawal approved" },
  { _id: 8, name: "Withdrawal request rejected" },
  { _id: 10, name: "Deposit Bonus" },
  { _id: 12, name: "Penalty or Charges" },
];
export const transContestOption = [
  { _id: 2, name: "Join League" },
  { _id: 4, name: "Refund" },
  { _id: 9, name: "Won the league" },
  { _id: 14, name: "Duplicate Refunds" },
  { _id: 15, name: "FE Refunds" },
];
export const transCoinOption = [
  { _id: 17, name: "Buy Coins" },
  { _id: 18, name: "Add Coins" },
  { _id: 19, name: "CoinReward Redeem" },
  { _id: 20, name: "Buy Coins + Avatar" },
  { _id: 21, name: "Buy Avatar" },
];
export const transCouponOption = [
  { _id: 1, name: "Promotional" },
  { _id: 3, name: "Referral" },
  { _id: 11, name: "SignUp Codes" },
  { _id: 13, name: "Signup Bonus" },
];
export const transDailyRewardOption = [
  { _id: 16, name: "DailyReward" },
  { _id: 22, name: "One Time Coin Bonus" },
];
export const PaymentTypeAllOption = [
  { _id: 1, name: "Promotional" },
  { _id: 2, name: "Join League" },
  { _id: 3, name: "Referral" },
  { _id: 4, name: "Refund" },
  { _id: 5, name: "Add Balance" },
  { _id: 6, name: "Withdrawal Requested" },
  { _id: 7, name: "Withdrawal approved" },
  { _id: 8, name: "Withdrawal request rejected" },
  { _id: 9, name: "Won the league" },
  { _id: 10, name: "Deposit Bonus" },
  { _id: 11, name: "SignUp Codes" },
  { _id: 12, name: "Penalty or Charges" },
  { _id: 13, name: "Signup Bonus" },
  { _id: 14, name: "Duplicate Refunds" },
  { _id: 15, name: "FE Refunds" },
  { _id: 16, name: "DailyReward" },
  { _id: 17, name: "Buy Coins" },
  { _id: 18, name: "Add Coins" },
  { _id: 19, name: "CoinReward Redeem" },
  { _id: 20, name: "Buy Coins + Avatar" },
  { _id: 21, name: "Buy Avatar" },
  { _id: 22, name: "One Time Coin Bonus" },
  { _id: 23, name: "Earn Coins" },
];
export const sizePerPageList = [
  { text: "10", value: 10 },
  { text: "20", value: 20 },
  { text: "30", value: 30 },
  { text: "50", value: 50 },
  { text: "100", value: 100 },
  { text: "200", value: 220 },
];
export const CONTEST_AUDIT_STATUS = ["Pending", "Completed"];
export const CONTEST_AUDIT_STATUS_BG = ["bg-info", "bg-primary"];
export const CONTEST_STATUS = {
  waiting: "waiting",
  Waiting: "waiting",
  started: "started",
  Started: "Started",
  inProcess: "in Process",
  review: "review",
  "In Progress": "In Progress",
  "In Review": "In Review",
  cancelled: "cancelled",
  Canceled: "canceled",
  completed: "completed",
  Completed: "completed",
};
export const EarnCoiinTypes = [
  { _id: "dailyLogin", name: "Daily Login" },
  { _id: "completeProfile", name: "Complete Profile Creation" },
  { _id: "oneInGameName", name: "Add 1 Game InGameName" },
  { _id: "join1stContest", name: "Join 1st Contest" },
  { _id: "join1stTournament", name: "Join 1st Tournament" },
  { _id: "getRanksIn1stContest", name: "Get a Ranks in 1st Contest" },
  { _id: "getRanksIn1stTournament", name: "Get a Ranks in 1st Tournaments" },
  { _id: "htmlGamesPlayed", name: "Free Games - HTML Games Played" },
  { _id: "onLevelUpgradation", name: "On Level Upgradation" },
  { _id: "onFollowing", name: "On Following" },
  { _id: "onFollowers", name: "On Followers" },
  { _id: "1stPackBuy", name: "1st Pack Buy" },
  { _id: "1stRedeem", name: "1st Redeem" },
  { _id: "5SuccesffulReferrals", name: "5 succesfful referrals" },
  { _id: "onSelectFavouriteGames", name: "On Selecting Favourite Games" },
  { _id: "onAddColleges", name: "On Adding Colleges" },
  { _id: "addAllGamesInGameName", name: "Add All Games InGameName" },
];
export const EarnCoiinTypesDisplay = {
  dailyLogin: "Daily Login",
  completeProfile: "Complete Profile Creation",
  oneInGameName: "Add 1 Game InGameName",
  join1stContest: "Join 1st Contest",
  join1stTournament: "Join 1st Tournament",
  getRanksIn1stContest: "Get a Ranks in 1st Contest",
  getRanksIn1stTournament: "Get a Ranks in 1st Tournaments",
  htmlGamesPlayed: "Free Games - HTML Games Played",
  onLevelUpgradation: "On Level Upgradation",
  onFollowing: "On Following",
  onFollowers: "On Followers",
  "1stPackBuy": "1st Pack Buy",
  "1stRedeem": "1st Redeem",
  "5SuccesffulReferrals": "5 succesfful referrals",
  onSelectFavouriteGames: "On Selecting Favourite Games",
  onAddColleges: "On Adding Colleges",
  addAllGamesInGameName: "Add All Games InGameName",
};
export const CONTEST_STATUS_BTN = {
  waiting: "btn-dark",
  Waiting: "btn-dark",
  started: "btn-light",
  inProcess: "btn-info",
  review: "btn-warning",
  "In Review": "btn-warning",
  Started: "btn-light",
  "In Progress": "btn-warning",
  cancelled: "btn-danger",
  Canceled: "btn-danger",
  completed: "bg-green",
  Completed: "btn-primary",
};
export const CONTEST_STATUS_BG = {
  waiting: "bg-dark",
  Waiting: "bg-dark",
  started: "bg-light",
  Started: "bg-light",
  inProcess: "bg-info",
  review: "bg-warning",
  "In Review": "bg-warning",
  "In Progress": "bg-warning",
  cancelled: "bg-danger",
  Canceled: "bg-danger",
  completed: "bg-green",
  Completed: "bg-primary",
};
export const CONTEST_STATUS_BG_TABLE = {
  waiting: "bg-dark",
  Waiting: "bg-dark",
  started: "bg-light",
  Started: "bg-light",
  inProcess: "bg-info",
  review: "bg-warning",
  "In Review": "bg-warning",
  "In Progress": "bg-warning",
  cancelled: "bg-danger",
  Canceled: "bg-danger",
  completed: "bg-green",
  Completed: "bg-green",
};
export const CONTEST_STATUS_TEXT = {
  waiting: "text-white",
  Waiting: "text-white",
  started: "text-dark",
  Started: "text-dark",
  inProcess: "text-white",
  review: "text-white",
  "In Review": "text-white",
  "In Progress": "text-white",
  cancelled: "text-white",
  Canceled: "text-white",
  completed: "text-white",
  Completed: "text-white",
};
export const CONTEST_STATUS_BORDER = {
  waiting: "border-dark",
  Waiting: "border-dark",
  started: "border-light",
  Started: "border-light",
  inProcess: "border-info",
  review: "border-warning",
  "In Review": "border-warning",
  "In Progress": "border-warning",
  cancelled: "border-danger",
  Canceled: "border-danger",
  completed: "border-primary",
  Completed: "border-primary",
};

export const AVAILABLE_COLORS = [
  "Red",
  "CadetBlue",
  "Eagle",
  "Gold",
  "LightSlateGrey",
  "RoyalBlue",
  "Crimson",
  "Blue",
  "Sienna",
  "Indigo",
  "Green",
  "Violet",
  "GoldenRod",
  "OrangeRed",
  "Khaki",
  "Teal",
  "Purple",
  "Orange",
  "Pink",
  "Black",
  "DarkTurquoise",
];

export const AVAILABLE_MANUFACTURES = [
  "Pontiac",
  "Kia",
  "Lotus",
  "Subaru",
  "Jeep",
  "Isuzu",
  "Mitsubishi",
  "Oldsmobile",
  "Chevrolet",
  "Chrysler",
  "Audi",
  "Suzuki",
  "GMC",
  "Cadillac",
  "Infinity",
  "Mercury",
  "Dodge",
  "Ram",
  "Lexus",
  "Lamborghini",
  "Honda",
  "Nissan",
  "Ford",
  "Hyundai",
  "Saab",
  "Toyota",
];
